import { http } from '@/api/config';

const state = {
  user: JSON.parse(localStorage.getItem('vibbra-user')) || undefined,
};

const actions = {
  loginClient(context, response) {
    context.commit('LOGIN_CLIENT', response);
  },
  loginVibbrante(context, response) {
    context.commit('LOGIN_VIBBRANTE', response);
  },
  logout(context) {
    context.commit('LOGOUT');
  },
  registerClient(context, response) {
    context.commit('REGISTER_CLIENT', response);
  },
  registerVibbrante(context, response) {
    context.commit('REGISTER_VIBBRANTE', response);
  },
  updateName(context, name) {
    context.commit('UPDATE_NAME', name);
  },
  acceptedTerm(context) {
    context.commit('ACCEPTED_TERM');
  },
  releaseRegister(context) {
    context.commit('RELEASE_REGISTER');
  },
};
const mutations = {
  ACCEPTED_TERM: state => {
    state.user.accepted_term = true;
    localStorage.setItem('vibbra-user', JSON.stringify(state.user));
  },
  RELEASE_REGISTER: state => {
    state.user.release_access = true;
    localStorage.setItem('vibbra-user', JSON.stringify(state.user));
  },
  UPDATE_NAME: (state, name) => {
    state.user.name = name;
  },
  LOGIN_CLIENT: (state, response) => {
    state.user = {};
    state.user.id = response.data.data.id;
    state.user.type = 'client';
    state.user.name = response.data.data.name;
    state.user.email = response.data.data.email;
    state.user.access_token = response.headers['access-token'];
    state.user.client_code = response.headers.client;
    state.user.expiry = response.headers.expiry;
    state.user.uid = response.headers.uid;
    state.user.release_access = response.data.data.release_access;
    state.user.hide_value_hour = response.data.data.hide_value_hour;
    state.user.accepted_term = response.data.data.accepted_term;
    localStorage.setItem('vibbra-user', JSON.stringify(state.user));
    http.defaults.headers.common['access-token'] =
      response.headers['access-token'];
    http.defaults.headers.common.client = response.headers.client;
    http.defaults.headers.common.expiry = response.headers.expiry;
    http.defaults.headers.common['token-type'] = 'Bearer';
    http.defaults.headers.common.uid = response.headers.uid;
  },
  LOGIN_VIBBRANTE: (state, response) => {
    state.user = {};
    state.user.id = response.data.data.id;
    state.user.type = 'vibbrante';
    state.user.name = response.data.data.name;
    state.user.email = response.data.data.email;
    state.user.access_token = response.headers['access-token'];
    state.user.client_code = response.headers.client;
    state.user.expiry = response.headers.expiry;
    state.user.uid = response.headers.uid;
    state.user.accepted_term = response.data.data.accepted_term;
    localStorage.setItem('vibbra-user', JSON.stringify(state.user));
    http.defaults.headers.common['access-token'] =
      response.headers['access-token'];
    http.defaults.headers.common.client = response.headers.client;
    http.defaults.headers.common.expiry = response.headers.expiry;
    http.defaults.headers.common['token-type'] = 'Bearer';
    http.defaults.headers.common.uid = response.headers.uid;
  },
  LOGOUT: state => {
    state.user = undefined;
    localStorage.removeItem('vibbra-user');
    http.defaults.headers.common['access-token'] = '';
    http.defaults.headers.common.client = '';
    http.defaults.headers.common.expiry = '';
    http.defaults.headers.common['token-type'] = 'Bearer';
    http.defaults.headers.common.uid = '';
  },
  REGISTER_CLIENT: (state, response) => {
    state.user = {};
    state.user.type = 'client';
    state.user.name = response.data.data.name;
    state.user.email = response.data.data.email;
    state.user.access_token = response.headers['access-token'];
    state.user.client_code = response.headers.client;
    state.user.expiry = response.headers.expiry;
    state.user.uid = response.headers.uid;
    localStorage.setItem('vibbra-user', JSON.stringify(state.user));
    http.defaults.headers.common['access-token'] =
      response.headers['access-token'];
    http.defaults.headers.common.client = response.headers.client;
    http.defaults.headers.common.expiry = response.headers.expiry;
    http.defaults.headers.common['token-type'] = 'Bearer';
    http.defaults.headers.common.uid = response.headers.uid;
  },
  REGISTER_VIBBRANTE: (state, response) => {
    state.user = {};
    state.user.type = 'vibbrante';
    state.user.id = response.data.data.id;
    state.user.name = response.data.data.name;
    state.user.email = response.data.data.email;
    state.user.access_token = response.headers['access-token'];
    state.user.client_code = response.headers.client;
    state.user.expiry = response.headers.expiry;
    state.user.uid = response.headers.uid;
    localStorage.setItem('vibbra-user', JSON.stringify(state.user));
    http.defaults.headers.common['access-token'] =
      response.headers['access-token'];
    http.defaults.headers.common.client = response.headers.client;
    http.defaults.headers.common.expiry = response.headers.expiry;
    http.defaults.headers.common['token-type'] = 'Bearer';
    http.defaults.headers.common.uid = response.headers.uid;
  },
};
const getters = {
  isLoggedIn: state => !!state.user,
  user: state => state.user,
};

export default {
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js